var jq = jQuery.noConflict();

var companyVars = JSON.parse(document.getElementById("companyVars").innerText),
    hCaptchaSiteKey = companyVars.hCaptchaSiteKey;

var captchaIDs = {};
function hCaptchaOnLoad () {
    jq('.h-captcha').each(function () {
        var form = jq(this).closest('form');
        window.captchaIDs[form[0].id] = hcaptcha.render(this.id, {
            "sitekey" : window.hCaptchaSiteKey,
            "callback": function (token) {
                jq('<input>', {
                    type: 'hidden',
                    name: 'h-captcha-response',
                    value: token
                }).appendTo(form);
                form.submit();
            }
        });
    });
}

// Adds asterisk to the labels of required form inputs
function addRequiredAsteriskToLabels() {
    jq("form .required").siblings("label").each(function () {
        var currentText = jq(this).text();
        jq(this).text(currentText + "*");
    });
}

jq(document).ready(function() {
    addRequiredAsteriskToLabels();
    
    new WOW().init();
    
    jq('.wow.reveal').each(function(){
        jq(this).append('<div class="animation-overlay"></div>');
    });
    
    jq('.video-section').each(function(){
        jq(this).click(function(){
            vid = jq(this).find('video')[0];
            if(jq(this).hasClass('active')) {
                jq(this).removeClass('active');
                vid.pause();
            } else {
                jq(this).addClass('active');
                vid.play();
            }
        });
    });
    
    //var rellax = new Rellax('.rellax');
    
    // Scroll more home hero button
    var scrollMore = document.getElementById('scroll-more');
    if (scrollMore) {
        jq(scrollMore).click(function (e) {
            e.preventDefault();
            var target = jq(this).closest('.home-hero').siblings('.module').first();
            jq('html,body').animate({
                scrollTop: target.offset().top - jq('.general-wrapper > header').height()
            }, 'slow');
        });
    }
    
    jq('.mobile-nav-trigger').click(function(){
        jq('.main-nav').css('height', 'auto');
    });
    
    //Set Cursor pointer to anything with data-toggle
    jq("*[data-toggle]").css( 'cursor', 'pointer' );
    
    jq('header.affixed').affix({
        offset:{
            top: 1
        }
    });
    
    //Circle Stat with Percentage Animation
    var divPercentage = jq('.stats-row-w-percents');
    if(divPercentage.length) {
        jq(document).bind('scroll', function(ev) {
            var scrollOffset = jq(document).scrollTop();
            var containerOffset = jq('.stats-row-w-percents').offset().top - window.innerHeight;
            if (scrollOffset > containerOffset) {
                jq('.stats-row-w-percents .stat').each(function() {
                    var percDiv = jq(this).find('.number'),
                    svgElm = jq(this).find('.circle'),
                    percentNumber = jq(this).attr('data-percent');
                    svgElm.attr('stroke-dasharray', percentNumber + ', 100');
                    svgElm.addClass('active');
                    jq({percentage: 0}).stop(true).animate({percentage: percentNumber}, {
                        duration : 2000,
                        step: function () {
                        var percentageVal = Math.round(this.percentage);
                        percDiv.text(percentageVal + '%');
                    }
                    }).promise().done(function () {
                        percDiv.text(percentNumber + "%");
                    });
                });
                jq(document).unbind('scroll');
            }
        });
    }
    
    var subNav = jq('.sub-navigation.affixed');
    if(subNav.length) {
        jq(subNav).affix({
            offset: { 
                top: jq(".sub-navigation").offset().top - jq("header").outerHeight()
            }
        });
    }

    var menuRight = document.getElementById( 'mobile-nav' ),
    showRight = document.getElementById( 'showRight' ),
    body = document.body;
    
    if (showRight) {
        showRight.onclick = function() {
            jq(this).toggleClass("active");
            jq('body').toggleClass('push-to-left');
            jq(menuRight).toggleClass("cbp-spmenu-open");
            disableOther( 'showRight' );
            toggleMenuKeybind();
        };
    }
    function disableOther( button ) {
        if( button !== 'showRight' ) {
          jq(showRight).toggleClass("disabled");
        }
    }
    
    /**
     * This function handles keydown events when a full screen nav is present, allowing
     * the navigation to be closed by pressing the esc key
     */
    
     function toggleMenuKeybind() {
        var $body = jq('body'),
            $body_events = $body.data("events");
            
        if ($body_events !== null && typeof($body_events.keydown) !== undefined) {
            $body.off('keydown');
        }else {
        $body.on('keydown', function(e) {
            if (e.which == 27) {
                jq('.main-nav').toggleClass("active");
                jq('body').toggleClass('push-to-left');
                jq(menuRight).toggleClass("cbp-spmenu-open");
                disableOther( 'showRight' );
                $body.off('keydown');
            }
        });
        }
    }

    // Basic Form Validation
    var validator = jq(".validate-form");
    
    validator.each( function() {
        var $form = jq(this),
            formID = this.id;

        // Build per-field messages that name the field, using its <label> text
        // so errors read e.g. "Name is required." instead of "This field is required."
        var fieldMessages = {};
        $form.find("input[name], select[name], textarea[name]").each(function() {
            var $field = jq(this);
            var fieldName = $field.attr("name");
            if (!fieldName || fieldMessages[fieldName]) {
                return;
            }
            var labelText = jq("label[for='" + $field.attr("id") + "']").first().text();
            // Strip the required-asterisk and any trailing punctuation/colon
            labelText = jq.trim(labelText.replace(/[*:\s]+$/, ""));
            if (!labelText) {
                return;
            }
            fieldMessages[fieldName] = {
                required: labelText + " is required.",
                email: "Please enter a valid " + labelText.toLowerCase() + ".",
                minlength: jq.validator.format("Please enter at least {0} characters for " + labelText + "."),
                maxlength: jq.validator.format("Please enter no more than {0} characters for " + labelText + ".")
            };
        });

        // Field-specific message overrides
        if (fieldMessages.name) {
            fieldMessages.name.required = "Please enter your name.";
        }
        if (fieldMessages.email) {
            fieldMessages.email.required = "Please enter your email address.";
        }

        $form.validate({
            errorElement: "span",
            errorClass: "error eq-error",
            messages: fieldMessages,
            errorPlacement: function(error, element) {
                var elementId = element.attr("id");
                var errorId = elementId + "-error";
                error.attr("id", errorId);
                element.attr("aria-describedby", errorId);
                element.attr("aria-invalid", "true");

                if (element.attr("type") === "radio") {
                    error.prependTo( element.parent() );
                } else {
                    error.appendTo( element.parent() );
                }
            },
            success: function(label) {
                // Remove the error message and its ARIA associations on successful validation
                var elementId = label.attr("id").replace('-error', '');
                var inputElement = jq('#' + elementId);

                inputElement.removeAttr("aria-describedby");
                inputElement.removeAttr("aria-invalid");
                label.remove();
            },
            submitHandler: function(form) {
                // Forms without an hCaptcha widget (login, password reset, unsubscribe) submit directly
                if (typeof window.captchaIDs[formID] === 'undefined' || typeof hcaptcha === 'undefined') {
                    form.submit();
                } else if (hcaptcha.getResponse(window.captchaIDs[formID])) {
                    form.submit();
                } else {
                    hcaptcha.reset(window.captchaIDs[formID]);
                    hcaptcha.execute(window.captchaIDs[formID]);
                }
            }
        });
    });
    
    jq.validator.methods.email = function( value, element ) {
      return this.optional( element ) || /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test( value );
    }
    
    jq('.toggle-button').click(function() {
        jq(this).toggleClass("open");
    });
    
    jq('.fancybox').fancybox({
        helpers: {
            overlay: {
                locked: true
            }
        },
        minHeight: '600'
    });
    jq('.fancybox-sec-filing').fancybox({
        helpers: {
            overlay: {
                locked: true
            }
        },
        minHeight: '900'
    });
    
    jq('.fancybox-bio').fancybox({
        helpers: {
            overlay: {
                locked: true
            }
        },
        minHeight: '0'
    });
    
    jq('.fancybox-modal').fancybox({
        width: 970,
        autoSize: false,
        height: 'auto'
    });
    
    jq(".fancybox\\.iframe").fancybox({
        type: 'iframe',
        iframe : {
            css : {
                width : '80%',
                maxWidth: '1024px',
            }
        }
    });
    
    //File input
    var fileInput = jq('.file-text input');
    fileInput.change(function(e){
        $this = jq(this);
        var val = $this.val().split('\\');
        var length = val.length;
        var filename = val[length-1];
        jq(this).parent('.file-text').children('.text-wrapper').text(filename);
    });

    // SEC Filing Filters - auto submit form
    jq('#sec-filing-filter select').on('change', function(e) {
        jq(this).closest('form').submit(); 
    });

    // Minor Announcement: when the header is taken out of normal flow
    // (position: absolute on the home page), the banner would render
    // underneath it. Measure the header height in that case and expose it
    // as --minor-announcement-offset so the banner can margin-top itself
    // down to sit just below the header. Interior pages keep the header in
    // flow, so the offset stays at 0 and the banner sits naturally below
    // the header without any adjustment.
    function updateMinorAnnouncementOffset() {
        var header = document.querySelector('.main-header');
        var banner = document.querySelector('.minor-announcement');
        if (!header || !banner) {
            document.documentElement.style.setProperty('--minor-announcement-offset', '0px');
            return;
        }
        var headerPosition = window.getComputedStyle(header).position;
        var offset = (headerPosition === 'absolute' || headerPosition === 'fixed') ? header.offsetHeight : 0;
        document.documentElement.style.setProperty('--minor-announcement-offset', offset + 'px');
    }
    updateMinorAnnouncementOffset();
    jq(window).on('resize', updateMinorAnnouncementOffset);

    // Major Announcement: open as modal once per active announcement timestamp.
    // Uses 7-day cookie (eqMajorAnnouncement) keyed by record's updated_at to
    // re-prompt visitors when the announcement is updated.
    var $majorAnnouncement = jq("#majorAnnouncement");
    var majorAnnouncementCookieName = "eqMajorAnnouncement";
    if ($majorAnnouncement.length) {
        var majorAnnouncementTimestamp = $majorAnnouncement.data("timestamp");
        var majorAnnouncementCookie = Cookies.get(majorAnnouncementCookieName);
        if (majorAnnouncementCookie != majorAnnouncementTimestamp) {
            var announcements = new EqDialog({
                show_close_button: true,
            });
            announcements.open("inline", "majorAnnouncement");
            Cookies.set(majorAnnouncementCookieName, majorAnnouncementTimestamp, { secure: true, domain: window.location.hostname, expires: 7 });
        }
    }

});

// Equal Heights
jq(window).on('load', function() {
    checkWidth();
});

//Smooth scroll to
function goToByScroll(id) {
    jq('html,body').animate({
        scrollTop: jq(id).offset().top - 250
    }, 'slow');
}
jq('.smooth').click(function() {
    goToByScroll(jq(this).attr('href'));
    return false;
});

//Smooth scroll with page link hash 
jq(window).ready(function() {
    if (window.location.hash) {
      if (jq(window.location.hash).length > -1) {
        goToByScroll(window.location.hash);          
      }
    }
});
// Team Filtering
if (jq('#team-mixer').length) {
    var mixer = mixitup('#team-mixer', {
        //Load executve team by default per client rquest
        load: {
            filter: '.executive'
        },
        multifilter: {
            enable: true
        },
        animation: {
            enable: true
        },
        callbacks: {
            onMixStart: function(state, futureState) {
                jq(".team-row p.failed").remove(); 
            },
            onMixFail: function(state) {
               var message  = "<p class='center failed'>No Items found</p>";
               jq(".team-row").prepend(message);
            },
            onMixEnd: function(state, futureState) {

            }
    
        }
    });
    jq('select.mixitup-filter').on('change', function () {
        var val = "." + jq(this).val();
        if (val == 'dropdown') {
            return;    
        }
        var values = '';
        jq('select.mixitup-filter').each(function(i){
            var val = "." + jq(this).val();
            if (!val || val == 'all') {
                return;    
            }
            values += val;
        });
        if (!values || values == ' ') {
            values = 'all';    
        }
        mixer.filter(values);
    });
    jq(document).ready(function() {
        var values = '';
        jq('select.mixitup-filter').each(function(i) {
            var val = "." + jq(this).val();
            if (!val || val == 'all') {
                return;    
            }
            values += val;
        });
        if (!values || values == ' ') {
            values = 'all';    
        }
        mixer.filter(values);
        //Load executve team by default per client rquest
        // mixer.setFilterGroupSelectors('department');
        // mixer.parseFilterGroups();
        // mixer.configure({
        //     animation: {
        //         enable: true
        //     }
        // })
    });
}

// Transaction Filtering
jq('#transactions-filter-form select').on('change', function() {
    jq('#transactions-filter-form').submit();
    return;
});

// Conference Filtering
jq('#conference-filter-form select').on('change', function() {
    jq('#conference-filter-form').submit();
    return;
});
// team Filtering
jq('select.filter-department').on('change', function() {
    jq('select.filter-sector').val('mix');
    jq('select.filter-location').val('mix');
    jq('#team-filter-form').submit();
    //return;
});
jq('select.filter-sector').on('change', function() {
    jq('select.filter-location').val('mix');
    jq('#team-filter-form').submit();
    
});
//Check Width
var resizeTimer;
jq(window).resize(function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(checkWidth, 250);
});

function checkWidth() {
    if (jq(window).width() > 767) {
        jq('.js-same-height, .js-same-height-row').each(function() {
            jq(this).addClass('active');
        });
        sameHeight();
    } else {
        jq('.js-same-height, .js-same-height-row').each(function() {
            jq(this).removeClass('active');
        });
        jq(".js-same-height,.js-same-height-row .js-height").css('min-height', '').css('height', '');
    }
}

// Same Height
function sameHeight() {
    jq(".js-same-height-row").each(function() {
        var $maxHeight = 0,
            $window_width = jq(window).width();
        jq('.js-same-height', this).css({
            'height': 'auto',
            'min-height': 0
        });
        if ((jq(this).data('cutoff') && jq(this).data('cutoff') >= $window_width) || $window_width < 768) {
            return false;
        }
        jq('.js-same-height', this).each(function() {
            if (jq(this).outerHeight() > $maxHeight) {
                $maxHeight = jq(this).outerHeight();
            }
        }).css('min-height', $maxHeight);
        jq('.js-height', this).css({
            'height': $maxHeight,
            'min-height': 0
        });
    });
}